import { SearchParams } from '@/types/common'
import {
  Controller,
  CreateController,
  CreateOperationsRain,
  RunManualStation,
  SearchController,
  UpdateController,
  UpdateMultipleController,
} from '@/types/controller'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const controllerDataConfigApi = {
  getAll(searchParams: SearchController) {
    const url = `/api/controller`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getMk2Template(interfaceId: number) {
    const url = `api/setup/${interfaceId}/import/download-mk2-decoder`
    return axiosClient.get(url, {
      responseType: 'blob',
    })
  },

  uploadMk2DecoderFile(interfaceId: number, data: FormData) {
    const url = `api/setup/${interfaceId}/import/upload-mk2-decoder`
    return axiosClient.post<any>(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  getDecoderType(searchParams: SearchParams = {}) {
    const url = `/api/controller/decodertype`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getWaterTankTopValve(searchParams: SearchParams = {}) {
    const url = `/api/watertank/topup-valve`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  // getIOConfig(searchParams: SearchIOConfig) {
  //   const url = `/api/ioconfig`
  //   return axiosClient.get(url + queryStringify(searchParams))
  // },

  getIOConfig(
    interfaceId: number,
    address: number,
    type: number,
    twiId?: number,
  ) {
    var url = `/api/ioconfig/get-by-decoder?interfaceId=${interfaceId}&address=${address}&type=${type}`
    url += twiId ? `&twiId=${twiId}` : ''
    return axiosClient.get(url)
  },

  getIOConfiguration(interfaceId: number) {
    const url = `/api/ioconfig/get-by-multiple-decoders?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getIOConfigDecoder(interfaceId: number, address: number, type: number) {
    const url = `/api/ioconfig/getbydecoder?interfaceId=${interfaceId}&address=${address}&type=${type}`
    return axiosClient.get(url)
  },

  getIODetail(interfaceId: number) {
    const url = `/api/controller/get-details-input?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getAutoSyncDecoder(interfaceId: number) {
    const url = `/api/autosyncdata/manual-src-objectsync-io?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getById(interfaceId: string, id: string, address: string, twiId?: number) {
    var url = `/api/controller/getdetail?interfaceId=${interfaceId}&address=${address}&id=${id}`
    url += twiId ? `&twiId=${twiId}` : ''
    return axiosClient.get(url)
  },

  create(payload: CreateController) {
    const url = '/api/controller'
    return axiosClient.post(url, payload, {
      timeout: 30000,
    })
  },

  createRainOperation(payload: CreateOperationsRain) {
    const url = '/api/waterengine/rain-operation'
    return axiosClient.patch(url, payload)
  },

  runManualStation(payload: RunManualStation) {
    const url = '/api/station/manual-run'
    return axiosClient.post(url, payload)
  },

  getStationOn(payload: any) {
    const interfaceId = payload.interfaceId
    const id = payload.id
    const url = `/api/station/on?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.get(url)
  },

  getStationOff(payload: any) {
    const interfaceId = payload.interfaceId
    const id = payload.id
    const url = `/api/station/off?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.get(url)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/controller/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdateController) {
    const url = '/api/controller'
    return axiosClient.put(url, payload)
  },

  updateConfiguration(payload: UpdateMultipleController) {
    const url = '/api/controller/apply-cfg-multiple'
    return axiosClient.put(url, payload)
  },
  getdetailforstationbyordinal(id: number) {
    const url = `/api/controller/getdetailforstationbyordinal?id=${id}`
    return axiosClient.get<Controller>(url)
  },

  runManualWithTimeStation(payload: RunManualStation) {
    const url = '/api/station/manual-run-with-time'
    return axiosClient.post(url, payload)
  },
}

export default controllerDataConfigApi
